import React from "react";
import { Button } from "Components/Base/Inputs/Button";

/**
 * ButtonUnderlined component
 *
 * A custom button component that renders an underlined text button with optional icon.
 *
 * @param {Function} onClick - The function to be called when the button is clicked
 * @param {string} label - The text to be displayed on the button
 * @param {string} [icon] - The CSS class name for the icon to be displayed at the end of the button
 * @param {string} [toolTipTitle] - The text to be displayed in the tooltip
 * @param {string|number} [fontWeight] - The font weight of the button text
 * @param {boolean} [hoverEffect=true] - Whether to show hover background effect
 * @param {boolean} [noWrap=false] - Whether to prevent text wrapping
 * @param {string} [id] - Custom ID for the button element. If not provided, generates random ID
 * @param {React.ReactNode} [startIcon] - Icon element to display at the start of the button
 * @param {string} [size="small"] - Size of the button. One of: "small", "medium", "large"
 * @returns {React.Element} A Button component with underlined text and optional icon
 */
const ButtonUnderlined = ({
  onClick,
  label,
  icon,
  toolTipTitle,
  fontWeight,
  hoverEffect = true,
  noWrap = false,
  disabled = false,
  id,
  startIcon,
  size = "small",
}) => (
  <Button
    id={
      id ||
      `${label ? label.replace(/\s+/g, "") + "-" : ""}${Math.floor(Math.random() * 10000)}`
    }
    onClick={onClick}
    endIcon={icon && <span className={icon} aria-hidden="true" />}
    startIcon={startIcon}
    color="secondary"
    size={size}
    variant="text"
    toolTipTitle={toolTipTitle}
    disabled={disabled}
    sx={{
      padding: 0,
      justifyContent: "start",
      whiteSpace: noWrap ? "nowrap" : "normal",
      "&:hover": {
        backgroundColor: hoverEffect ? undefined : "transparent",
      },
    }}
  >
    <span
      style={{
        fontSize: "14px",
        textDecoration: "underline",
        "&:hover": { textDecoration: "underline" },
        fontWeight,
      }}
    >
      {label}
    </span>
  </Button>
);

export default ButtonUnderlined;
